export default __webpack_public_path__ + "static/media/wh_ep1_accuse_character__angel2.d23216bc.jpg";